import megatron from '@stencil/megatron';
import { get } from '@stencil/megatron';
import { PETHOES_API_URL } from '@stencil/flights-constants/src/urls';
import { INTERNAL_PETHOES_API_URL } from '@stencil/flights-constants/src/urls';

export async function PethoesAPI(requestObj, pdtApiFailureError = err => {}) {
  const url = `${PETHOES_API_URL}?`;
  let param = '';

  const paramObj = { ...requestObj }; // default flavour and v if not provided
  Object.keys(paramObj).forEach(key => {
    if (param != '') {
      param += '&';
    }
    param += key + '=' + encodeURIComponent(paramObj[key]);
  });

  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;',
    'User-Agent':
      'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.159 Mobile Safari/537.36',
    'x-pfm': window.flavour || '',
    currency: 'inr',
    locale: 'en-IN'
  };

  const response = await megatron({
    name: 'Pethoes THOR API',
    headers: header,
    type: 'GET',
    url: url + param,
    credentials: 'omit',
    pdtApiFailureError
  });
  if (response) {
    return response;
  }
}

export const getPethoesApiData = async requestObj => {
  const url = `${INTERNAL_PETHOES_API_URL}?`;
  let param = '';

  const paramObj = { ...requestObj }; // default flavour and v if not provided
  Object.keys(paramObj).forEach(key => {
    if (param != '') {
      param += '&';
    }
    param += key + '=' + encodeURIComponent(paramObj[key]);
  });

  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;',
    'User-Agent':
      'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.159 Mobile Safari/537.36',
    'x-pfm': requestObj.flavour || '',
    currency: 'inr',
    locale: 'en-IN'
  };

  try {
    const response = await get(url + param, { name: 'Pethoes THOR API', headers: header });
    let error_msg = '';
    if (!response) {
      error_msg = '!resp';
    }
    return response.data;
  } catch (e) {
    console.log('ERROR fetching pethoes thor api data');
    return null;
  }
};
